module.exports = __webpack_public_path__ + "img/Most-Improved.178501c9.png";